import * as React from 'react'

import {IFeatureLayerInfo} from '../../interfaces/models'
import ReadOnlyView from './ReadOnlyView'
import FeatureEditor from './FeatureEditor'
import {IMapDispatcher, IEditsDispatcher} from '../../interfaces/dispatchers'
import {Feature, FeatureStatus} from '../../models'
import {IUser} from '../../interfaces/reducers'

interface Props {
  feature: Feature
  layerInfo: IFeatureLayerInfo
  style?: React.CSSProperties
  buttonsClassname?: string
  mapDispatcher?: IMapDispatcher
  editsDispatcher?: IEditsDispatcher
  hideCancel?: boolean
  hideDelete?: boolean
  hideSave?: boolean
  saveControlsTop?: boolean
  user?: IUser
  isEditable: () => boolean
  onAfterSave?: (feature: Feature) => void
  onAfterDelete?: () => void
  editAgain: (feature: Feature) => Feature
}

interface State {
  editing: boolean
}

class ReadOnlyEditSplitter extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      editing: false
    }
  }

  getEditButton() {
    return this.props.isEditable() && !this.state.editing ? (
      <div style={{display: 'flex'}}>
        <button
          type="button"
          className="button width margin"
          onClick={() => {
            this.setState({...this.state, editing: !this.state.editing})
          }}
        >
          {'Редакция'}
        </button>
      </div>
    ) : null
  }

  render() {
    const editable = this.props.isEditable()
    if (this.props.feature.status == FeatureStatus.Deleted) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            height: '100px',
            fontSize: '18px',
            backgroundColor: 'white'
          }}
        >
          Обектът е изтрит
        </div>
      )
    }
    return (
      <div className="read-edit-splitter" style={{...this.props.style, display: 'flex', flexDirection: 'column'}}>
        {this.getEditButton()}
        {this.state.editing ? this.getEditingComponent() : this.getReadOnlyComponent()}
      </div>
    )
  }

  getEditingComponent() {
    return (
      <FeatureEditor
        editAgain={this.props.editAgain}
        layerInfo={this.props.layerInfo}
        feature={this.props.feature}
        editsDispatcher={this.props.editsDispatcher}
        onAfterSave={g => {
          this.props.onAfterSave && this.props.onAfterSave(g)
        }}
        onAfterDelete={() => {
          this.props.onAfterDelete && this.props.onAfterDelete()
        }}
        saveControlsTop={this.props.saveControlsTop}
        onCancel={() => {
          this.setState({...this.state, editing: !this.state.editing})
        }}
        hideCancel={this.props.hideCancel}
        hideDelete={this.props.hideDelete}
        hideSave={this.props.hideSave}
        buttonsClassname={this.props.buttonsClassname}
        style={{margin: '10px'}}
      />
    )
  }

  getReadOnlyComponent() {
    return <ReadOnlyView layerInfo={this.props.layerInfo} feature={this.props.feature} style={{}} />
  }
}

export default ReadOnlyEditSplitter
